import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '@/assets/img/unhappy.png'
import _imports_1 from '@/assets/img/neutral.png'
import _imports_2 from '@/assets/img/happy.png'


const _hoisted_1 = { class: "satisfaction" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = {
  key: 5,
  class: "smileys"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.$t('satisfaction.title')) + " ", 1),
          _createVNode(_component_ReglePastille, { cle: "satisfaction.definition" }),
          _createVNode(_component_ReglePastille, { cle: "satisfaction.visibiliteMenu" }),
          _createVNode(_component_ReglePastille, { cle: "satisfaction.choixSociete" })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && _ctx.getSocietes.length > 1)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t('satisfaction.choix.societe.titre')), 1))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && _ctx.getSocietes.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_DropDown, {
            list: _ctx.getSocietes,
            selectedItem: _ctx.societeSelectionnee,
            display: _ctx.displaySociete,
            onSelect: _ctx.setSocieteSelectionnee,
            class: "drop-down",
            label: _ctx.$t('satisfaction.choix.societe.input')
          }, null, 8, ["list", "selectedItem", "display", "onSelect", "label"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.societeSelectionnee != undefined)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t('satisfaction.description')), 1))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 4 }))
      : _createCommentVNode("", true),
    (_ctx.societeSelectionnee != undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Pas content",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleClick(1)))
          }),
          _createElementVNode("img", {
            src: _imports_1,
            alt: "Neutre",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleClick(2)))
          }),
          _createElementVNode("img", {
            src: _imports_2,
            alt: "Content",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleClick(3)))
          }),
          _createVNode(_component_ReglePastille, { cle: "satisfaction.parcoursSelonNote" })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ]))
}